import { render } from "./privacy.vue?vue&type=template&id=a93f854e&scoped=true"
const script = {}

import "./privacy.vue?vue&type=style&index=0&id=a93f854e&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/sathikash_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a93f854e"]])

export default __exports__